export const Types = {
    GET_ISSUER_TOP_NUMBERS: 'GET_ISSUER_TOP_NUMBERS',
    GET_ISSUER_TOP_NUMBERS_SUCCESS: 'GET_ISSUER_TOP_NUMBERS_SUCCESS',
    GET_ISSUER_TOP_NUMBERS_ERROR: 'GET_ISSUER_TOP_NUMBERS_ERROR',
  };
  
  const INIT_STATE = {
    topNumbers: null,
    topNumbersLoading: false,
    topNumbersError: null,
  };
  
  export default function issuerDashboard(state = INIT_STATE, action) {
    switch (action.type) {
      case Types.GET_ISSUER_TOP_NUMBERS:
        return {
          ...state,
          topNumbers: null,
          topNumbersLoading: true,
          topNumbersError: null,
        };
      case Types.GET_ISSUER_TOP_NUMBERS_SUCCESS:
        return {
          ...state,
          topNumbers: action.payload,
          topNumbersLoading: false,
          topNumbersError: null,
        };
      case Types.GET_ISSUER_TOP_NUMBERS_ERROR:
        return {
          ...state,
          topNumbers: null,
          topNumbersLoading: false,
          topNumbersError: action.payload,
        };
  
      default:
        return state;
    }
  }
  
  export const Creators = {
    getIssuerTopNumbers: () => ({
      type: Types.GET_ISSUER_TOP_NUMBERS
    }),

    getIssuerTopNumbersSuccess: payload => ({
      type: Types.GET_ISSUER_TOP_NUMBERS_SUCCESS,
      payload,
    }),
    
    getIssuerTopNumbersError: payload => ({
      type: Types.GET_ISSUER_TOP_NUMBERS_ERROR,
      payload,
    }),
  
  };
  